interface RightGroupProps {
  children: React.ReactNode;
}

const RightGroup = ({ children }: RightGroupProps) => <div>{children}</div>;

export default RightGroup;
